/* unplugin-vue-components disabled */import { render } from "./E808B3AnswerBtn.vue?vue&type=template&id=67df2110&scoped=true"
import script from "./E808B3AnswerBtn.vue?vue&type=script&lang=js"
export * from "./E808B3AnswerBtn.vue?vue&type=script&lang=js"

import "./E808B3AnswerBtn.vue?vue&type=style&index=0&id=67df2110&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67df2110"]])

export default __exports__